import React, { useState, useEffect } from 'react';
import Highcharts, { chart } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import highchartsMap from 'highcharts/modules/map';
import { moneyFormatter } from '../../helper';
import { useSelector } from 'react-redux';
import { ID_ALL } from '../../constant/city';
import { title } from '../../constant/title';

highchartsMap(Highcharts);

const MapChart = ({ data }) => {
  const [result, setResult] = useState([]);

  const regionList = [
    'id-indo',
    'id-aceh',
    'id-kaltim',
    'SEMARANG',
    'id-bengkulu',
    'BANTEN',
    'id-kalbar',
    'id-belitung',
    'BALI',
    'SURABAYA',
    'id-kalsel',
    'id-ntt',
    'MAKASSAR',
    'id-kriau',
    'id-irian',
    'MEDAN',
    'PEKANBARU',
    'id-sulut',
    'id-malut',
    'id-sumbar',
    'id-maluku',
    'id-ntb',
    'id-sultra',
    'id-sulteng',
    'id-papua',
    'BANDUNG',
    'LAMPUNG',
    'JAKARTA',
    'id-gorontalo',
    'id-yogya',
    'id-kalteng',
    'PALEMBANG',
    'id-sulbar',
    'JAMBI',
  ];

  useEffect(() => {
    const res = regionList.map((city) => ({
      'hc-key': city,
      value: Math.max(
        ...data.result.map((car) => {
          const value = car.data.find((e) => e.city === city) || { value: 0 };
          return value.value;
        })
      ),
      values: data.result.map((car) => {
        const value = car.data.find((e) => e.city === city) || { value: 0 };
        return {
          name: car.name,
          value: value.value,
        };
      }),
    }));

    setResult(res);
  }, []);

  const options = {
    chart: {
      map: ID_ALL,
      renderTo: 'chart3',
      height: 320,
    },
    title: {
      text: '',
    },
    plotOptions: {
      map: {
        states: {
          hover: {
            color: '#f0a18c',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    colorAxis: {
      minColor: '#eeeeee',
      maxColor: '#005daf',
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    legend: {
      title: {
        text: `Index ${title(data.metric)}`,
      },
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      floating: false,
    },

    subtitle: {
      text: `Grafik ${title(data.metric)}`,
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const {
          key,
          point: { values = null },
        } = this;
        let labels = '';
        if (values) {
          for (let i = 0; i < values.length; i++) {
            const { name, value } = values[i];
            const money = value ? `Rp. ${moneyFormatter(value)}` : `-`;
            labels += `<tr style="font-size: 12px">
                    <td style="font-weight: bold">${name}</td>
                    <td style="padding:0px 5px;">: ${money}</td>
                    </tr>`;
          }
        }
        return `<span style="font-size:14px; font-weight: bold">${key}</span><table>
                    ${labels}
                </table>`;
      },
    },
    mapNavigation: {
      enableButtons: false,
      enableMouseWheelZoom: false,
    },
    series: [
      {
        mapData: ID_ALL,
        data: [...result],
        keys: ['hc-key', 'value'],
      },
    ],
  };

  return (
    <div id="chart3">
      <HighchartsReact highcharts={Highcharts} constructorType={'mapChart'} options={options} />
    </div>
  );
};

export default MapChart;
